import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { watch, onMounted } from 'vue'
import { useMq } from 'vue3-mq'

import AcModal from '@ui-kit/components/AcModal.vue'
import { postFirstDayModalShown, postFirstDayModalClosed } from '@web/services/Analytics/events'
import type { CloseMethod } from '@web/services/Analytics/events/postFirstDayModal'
import { usePostFirstDayModal } from '@web/platform.v3/composables/usePostFirstDayModal'
import ContinueInAppContent from './ContinueInAppContent.vue'
import SetupRemindersContent from './SetupRemindersContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PostFirstDayModal',
  setup(__props) {

const { isOpen, variant, close, showIfPending } = usePostFirstDayModal()
const mq = useMq()

// Вход в ЛК на любой странице: если модалка запланирована (вкладку закрыли, не показав) — показываем.
onMounted(() => {
  showIfPending()
})

function platformView (): 'mobile_web' | 'desktop_web' {
  return mq.current === 'desktop' ? 'desktop_web' : 'mobile_web'
}

// Событие показа — при открытии модалки
watch(isOpen, (open) => {
  if (open && variant.value) {
    postFirstDayModalShown({ modalType: variant.value, platformView: platformView() })
  }
})

function onClose (method: CloseMethod): void {
  if (variant.value) {
    postFirstDayModalClosed({ modalType: variant.value, closeMethod: method, platformView: platformView() })
  }
  close()
}

// Клик по бэкдропу (AcModal шлёт update:modelValue=false) — трактуем как закрытие крестиком
function onBackdrop (value: boolean): void {
  if (!value) onClose('cross_button')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AcModal, {
    "model-value": _unref(isOpen),
    "mobile-modal-type": "bottomSheet",
    "onUpdate:modelValue": onBackdrop
  }, {
    default: _withCtx(() => [
      (_unref(variant) === 'continue_in_app')
        ? (_openBlock(), _createBlock(ContinueInAppContent, {
            key: 0,
            onClose: onClose,
            onCta: _unref(close)
          }, null, 8, ["onCta"]))
        : (_unref(variant) === 'setup_reminders')
          ? (_openBlock(), _createBlock(SetupRemindersContent, {
              key: 1,
              onClose: onClose,
              onCta: _unref(close)
            }, null, 8, ["onCta"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})